import './LiveVoting.scss';

import {compose} from 'redux';
import {connect} from 'react-redux';
import React, {Component} from 'react';
import urlparam from 'urlparam';

import {connectEvent, connectI18n} from '../../connects';
import PlsWait from './PlsWaitScreen/PlsWait';
import ScreenSelection from './ScreenSelection';
import VotingFinished from './VotingFinished/VotingFinished';
import {defer} from 'lodash';

// TODO: move resPath property to either a webpack defined const or change the relative path from / to /static on the resources load config

class LiveVotingBase extends Component {
    static defaultProps = {
        resPath: '/',
    };
    constructor(props) {
        super(props);
        this.state = {
            finished: false,
            answers: {},
            settings: {},
        };
        this.handleScreenUpdate = this.handleScreenUpdate.bind(this);
        this.handleSettingsUpdate = this.handleSettingsUpdate.bind(this);
        this.handleAnswersReset = this.handleAnswersReset.bind(this);
        this.handleSessionStopped = this.handleSessionStopped.bind(this);
        this.handleSetupChannel = this.handleSetupChannel.bind(this);
        this.handleResultsUpdate = this.handleResultsUpdate.bind(this);
    }

    componentDidMount() {
        app.api.voting.socket.on('auth_success', this.handleSetupChannel);
        app.api.voting.socket.on('screen_update', this.handleScreenUpdate);
        app.api.voting.socket.on('settings_update', this.handleSettingsUpdate);
        app.api.voting.socket.on('answers_reset', this.handleAnswersReset);
        app.api.voting.socket.on('results_update', this.handleResultsUpdate);
        app.api.voting.socket.on('stop_session', this.handleSessionStopped);
        app.api.voting.socket.connect();
    }
    componentWillUnmount() {
        app.api.voting.socket.off('auth_success', this.handleSetupChannel);
        app.api.voting.socket.off('screen_update', this.handleScreenUpdate);
        app.api.voting.socket.off('settings_update', this.handleSettingsUpdate);
        app.api.voting.socket.off('answers_reset', this.handleAnswersReset);
        app.api.voting.socket.off('results_update', this.handleResultsUpdate);
        app.api.voting.socket.off('stop_session', this.handleSessionStopped);
        app.api.voting.socket.disconnect();

        if (this.timeout) clearTimeout(this.timeout);
    }

    componentDidUpdate() {
        if (this.state.finished && urlparam('autoclose')) {
            // autoclose
            this.timeout = setTimeout(() => {
                app.history.replace(urlparam('previous'));
                app.store.dispatch(app.actions.ui.sidePanel.maximize(true));
            }, 3000);
        }
    }

    render() {
        if (this.state.finished) {
            return <VotingFinished {...this.props} {...this.state} />;
        } else if (this.state.isLive && this.state.question) {
            return <ScreenSelection key={this.state.question.id} {...this.props} {...this.state} onVote={this.handleVote.bind(this)} />;
        }
        return <PlsWait {...this.props} />;
    }
    handleSetupChannel() {
        app.api.voting.socket
            .joinVotingSession(this.props.liveVotingId)
            .then(data => {
                this.setState(data);
                return app.api.voting.socket.fetchSettings(this.props.liveVotingId).then(this.handleSettingsUpdate);
            })
            .then(this.fetchPreviousAnswer.bind(this));
    }
    handleVote(optionId, optionValue) {
        let {question} = this.state;
        if (question) {
            app.store.dispatch(app.actions.ui.busy());
            app.api.voting.socket
                .sendAnswer(this.props.liveVotingId, question.id, optionId, optionValue)
                .then(() => {
                    this.setState({answers: {...this.state.answers, [question.id]: {optionId, optionValue}}});
                })
                .catch(err => {
                    console.warn('Unable to vote', err);
                })
                .then(() => app.store.dispatch(app.actions.ui.free()));
        }
    }
    handleScreenUpdate(data) {
        // console.log('screen update', data);
        this.setState({...data, finished: false});
        defer(this.fetchPreviousAnswer.bind(this));
    }
    handleSettingsUpdate(settings) {
        // console.log('settings_update', settings);
        this.setState({settings});
    }
    handleAnswersReset(questionId) {
        let answers = {...this.state.answers};
        delete answers[this.state.question.id];
        this.setState({answers});
    }
    handleResultsUpdate(data) {
        this.setState(data);
    }
    handleSessionStopped() {
        this.setState({finished: true});
    }
    fetchPreviousAnswer() {
        let {question} = this.state;
        if (question && question.id) {
            app.api.voting.socket.fetchPreviousAnswer(this.props.liveVotingId, question.id).then(value => {
                let answer;
                switch (question.answer_type) {
                    case 'text':
                        if (value && value.toString().length) {
                            answer = {optionValue: value};
                        }
                        break;
                    case 'options':
                        let option = this.state.question.options.find(option => option.id == value);
                        if (option) {
                            answer = {option, optionId: value};
                        }
                        break;
                }
                this.setState({
                    answers: {
                        ...this.state.answers,
                        [this.state.question.id]: answer,
                    },
                });
            });
        }
    }
}

export const ConnectedScreen = compose(
    connectEvent,
    connectI18n,
    connect((state, props) => ({
        userId: state.session.user.id,
    }))
)(LiveVotingBase);

export default props => <ConnectedScreen {...props.match.params} />;
